import { NetworkIdSchema } from "#network/network.js";
import { z } from "zod";
//#region src/logs/logs.ts
const LogSchema = z.object({
	id: z.string().min(1),
	appId: z.string(),
	appName: z.string(),
	network: NetworkIdSchema.optional(),
	method: z.string(),
	duration: z.number(),
	fcu: z.number(),
	numRequestsInBatch: z.number(),
	requestBody: z.string(),
	requestBodyIsValid: z.boolean(),
	requestQuery: z.string(),
	responseBody: z.string(),
	responseBodyIsValid: z.boolean(),
	responseErrorCode: z.number(),
	responseHttpStatusCode: z.number(),
	sentAt: z.string().datetime()
});
//#endregion
export { LogSchema };

//# sourceMappingURL=logs.js.map